import { Pipe, PipeTransform } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { DATEFORMAT, extractTimezoneFromISOString } from 'core';
import { format, parseISO } from 'date-fns';
import { enUS, ru } from 'date-fns/locale';

type DateFormat = 'date' | 'time' | 'dateWithTime' | 'dateWithTimeAndSeconds' | 'dateWithoutTimeZone' | 'dateLong';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
    constructor(private localeService: I18NextService) {}
    // eslint-disable-next-line complexity
    public transform(value: Date | string | number, currentFormat: DateFormat, showTimezone = false): string {
        if (!value) {
            return '';
        }
        const resultDate = typeof value === 'string' ? parseISO(value) : value;

        const isCurrentLanguageRussian = this.localeService.language === 'ru';
        const currentLocale = isCurrentLanguageRussian ? ru : enUS;

        let dateFormat = '';
        switch (currentFormat) {
            case 'date':
                dateFormat = isCurrentLanguageRussian ? DATEFORMAT.dateRu : DATEFORMAT.dateEn;
                break;
            case 'dateLong':
                dateFormat = isCurrentLanguageRussian ? DATEFORMAT.dateLongRu : DATEFORMAT.dateLongEn;
                break;
            case 'time':
                dateFormat = isCurrentLanguageRussian ? DATEFORMAT.time : DATEFORMAT.time;
                break;
            case 'dateWithTime':
                dateFormat = isCurrentLanguageRussian ? DATEFORMAT.dateWithTimeRu : DATEFORMAT.dateWithTimeEn;
                break;
            case 'dateWithTimeAndSeconds':
                dateFormat = isCurrentLanguageRussian ? DATEFORMAT.dateWithTimeAndSecondsRu : DATEFORMAT.dateWithTimeAndSecondsEn;
                break;
            default:
                throw new Error('В pipe dateFormat задан неверный формат даты');
        }

        let formattedDate = format(resultDate, dateFormat, { locale: currentLocale });

        // Добавляем часовой пояс, если нужно
        if (showTimezone) {
            const timezoneInfo = extractTimezoneFromISOString(resultDate);
            formattedDate += ` (${timezoneInfo})`;
        }

        return formattedDate;
    }
}
